import { BaseEntity } from "src/app/tools/models/baseEntity";
import { LoyaltyProgram } from "./loyalty-program";
import { LoyaltyProgramReleaseThreshold } from "./loyalty-program-release-threshold";


export class LoyaltyProgramRelease extends BaseEntity{
    
    loyaltyProgram                  : LoyaltyProgram;
    loyaltyProgramReleaseCode       : string;
    startDate                       : Date;
    endDate                         : Date;
    active                          : boolean;
    adjustvalue                     : number;
    loyaltyProgramReleaseThresholds : LoyaltyProgramReleaseThreshold[];

}
